import "animate.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { login, googleAuth } from '../store/authSlice.js';
import { useNavigate } from "react-router-dom";
import "../App.css";
import { toast } from "react-toastify";

const GoogleIcon = () => (
  <svg className="me-2" width="18" height="18" viewBox="0 0 18 18">
    <path fill="#4285F4" d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844c-.209 1.125-.843 2.078-1.796 2.717v2.258h2.908c1.702-1.567 2.684-3.874 2.684-6.615z"/>
    <path fill="#34A853" d="M9 18c2.43 0 4.467-.806 5.956-2.184l-2.908-2.258c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332C2.438 15.983 5.482 18 9 18z"/>
    <path fill="#FBBC05" d="M3.964 10.707c-.18-.54-.282-1.117-.282-1.707s.102-1.167.282-1.707V4.961H.957C.347 6.175 0 7.55 0 9s.348 2.825.957 4.039l3.007-2.332z"/>
    <path fill="#EA4335" d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0 5.482 0 2.438 2.017.957 4.961L3.964 7.293C4.672 5.163 6.656 3.58 9 3.58z"/>
  </svg>
);

const Signin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handle = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await dispatch(login({ email, password })).unwrap();
      toast.success("Signed in successfully");
      navigate("/");
    } catch (err) {
      toast.error(err || "Sign in failed");
    } finally {
      setLoading(false);
    }
  };

  const handleGoogle = async () => {
    setLoading(true);
    try {
      const result = await dispatch(googleAuth()).unwrap();

      if (result.needsProfile) {
        // Google account exists in Firebase Auth but no profile in DB yet
        // Redirect to signup to complete profile
        toast.info("Please complete your profile to continue");
        navigate("/signup", { state: { googleUser: result } });
      } else {
        toast.success("Signed in with Google");
        navigate("/");
      }
    } catch (err) {
      toast.error(err || "Google sign in failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid vh-100">
      <div className="row h-100">
        <div className="col-md-6 d-none d-md-flex align-items-center justify-content-center">
          <img
            src="/slider/1.jpeg"
            alt="Aarnayours"
            className="img-fluid animate__animated animate__fadeInLeft"
            style={{ maxHeight: "80%", borderRadius: "24px" }}
          />
        </div>

        <div className="col-md-6 d-flex align-items-center justify-content-center">
          <div className="w-100 animate__animated animate__fadeInRight" style={{ maxWidth: "400px" }}>
            <h2 className="fw-bold mb-2 text-center">Welcome Back</h2>
            <p className="text-muted text-center mb-4">Sign in to AARNAYOURS</p>

            <form onSubmit={handle}>
              <input
                type="email"
                className="form-control mb-3 rounded-pill"
                placeholder="Email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <input
                type="password"
                className="form-control mb-3 rounded-pill"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <button className="btn btn-dark w-100 rounded-pill mb-3" disabled={loading}>
                {loading ? "Signing in..." : "Sign In"}
              </button>
            </form>

            <div className="text-center mb-3"><span className="text-muted">OR</span></div>

            <button
              type="button"
              className="btn btn-outline-dark w-100 rounded-pill mb-3 d-flex align-items-center justify-content-center"
              onClick={handleGoogle}
              disabled={loading}
            >
              <GoogleIcon />
              Continue with Google
            </button>

            <p className="text-center small mb-3">
              <a href="/forgot-password">Forgot Password?</a>
            </p>
            <p className="text-center small">
              Don't have an account? <a href="/signup">Sign up</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Signin;
